<span class="price" [ngClass]="size" [class.price-bold]="weight === 'bold'" [class.price-color]="hasPrimaryColor">
    @if (isIndicative) {
    <span class="indicative-price-label" i18n="@@hermes.product-grid.indicative-price">
        {{ price | hCurrency : format : currencyCode }} From
    </span>
    } @else {

    {{ price | hCurrency : format : currencyCode }}

    }
</span>
